import { Button, Modal } from '@fl/cmsch-fe-library';
import React, { Fragment, FC, memo } from 'react';
import { Ant } from 'common/ant';
import { ConnectedTable } from 'utils/tables';
import { columns } from './columns';
import { rowMapper } from './row-mapper';
import { useContactTabSetup } from '../../hooks/use-contact-tab-setup';
import { ContactsTabProps } from '../../types/contacts-tab-props';
import { ContactsForm } from '../contact-form';
const UserContactsTableBase: FC<ContactsTabProps> = props => {
  const {
    actionMode,
    actionSettings,
    contactOptions,
    contactsSelector,
    formDataForInit,
    getContacts,
    handleCloseModal,
    handleOpenCreateModal,
    handleSubmitModal,
    headerButtons,
    isFromAdminModule,
    pathnamesForRefresh,
    t,
    tCommon,
    userProfileId,
    validateDebounced,
    visibleModal
  } = useContactTabSetup(props);
  return <Fragment>
            <ConnectedTable tableId={isFromAdminModule ? 'userContacts' : 'userContactsProfile'} columns={columns(tCommon)} onFetchTableData={getContacts} rowDataPageSelector={contactsSelector} rowDataToTableRowMapper={rowMapper} actionSettings={actionSettings} headerButtons={headerButtons} withoutVerticalScrollbar paginationPosition="both" pathnamesForRefresh={pathnamesForRefresh} lazyLoadingLimit={20} showFulltextFilter enableTableSettings highlightOnEdit enableTableUserSettings emptyTableContent={isFromAdminModule ? <Button role="create" onClick={handleOpenCreateModal}>
                        {t('contact')}
                    </Button> : undefined} data-sentry-element="ConnectedTable" data-sentry-source-file="index.tsx" />
            {isFromAdminModule && <Modal title={t(actionMode === 'create' ? 'addContact' : 'editContact')} visible={visibleModal} onCancel={handleCloseModal} footer={null}>
                <Ant.Row>
                    <Ant.Col xs={24}>
                        <ContactsForm mode={actionMode} userProfileId={userProfileId} data={formDataForInit} contactOptions={contactOptions} onSyncValidate={validateDebounced} onCancel={handleCloseModal} onSubmit={handleSubmitModal} />
                    </Ant.Col>
                </Ant.Row>
            </Modal>}
        </Fragment>;
};

/**
 * Renders the contacts tab table and its create/edit contact modal when used from admin.
 *
 * @param props Contact table data, selectors, refresh paths, and optional admin actions.
 * @returns The contacts table plus the optional contact form modal.
 *
 * @example
 * <UserContactsTable {...contactsProps} />
 */
export const UserContactsTable = memo(UserContactsTableBase);